import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ApiSecret from './ApiSecret';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../../organisation/feature/helper';
import { useMe } from '../../organisation/useMe';
import SalvPage from '../../common/SalvPage';
import { SalvCard } from '@salvapp/ui-components';

const ApiConfiguration = () => {
  const { features } = useMe();

  const monitoringEnabled = isFeatureEnabled(ORGANISATION_FEATURE.MONITORING, features);
  const screeningEnabled = isFeatureEnabled(ORGANISATION_FEATURE.SANCTIONS, features);

  return (
    <SalvPage title={'API Configuration'}>
      {(monitoringEnabled || screeningEnabled) && (
        <Row>
          <Col>
            <SalvCard expansionOptions={{ isDefaultExpanded: true }}>
              <SalvCard.Header>API Secret</SalvCard.Header>
              <SalvCard.Body>
                <ApiSecret />
              </SalvCard.Body>
            </SalvCard>
          </Col>
        </Row>
      )}
    </SalvPage>
  );
};

export default ApiConfiguration;
